import { render, staticRenderFns } from "./BaseEditPageDatePicker.vue?vue&type=template&id=a5272a84"
import script from "./BaseEditPageDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseEditPageDatePicker.vue?vue&type=script&lang=js"
import style0 from "./BaseEditPageDatePicker.vue?vue&type=style&index=0&id=a5272a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports